export const NAMESPACE = "SelectDashboardFieldsModal";

export const TABS = {
  ALL: "all",
  REPORTED: "reported"
};

export const FIELD_TAB_ALL = "all";
export const FIELD_TAB_GLOBAL = "global";
export const FIELD_TAB_EVENT = "event";
